export class MessageAccount {
    Id_Message: number;
    IsInternal: number;
    IsExternal: number;
    IsHTML: number;
    MessageText: string;
    Assigned: string;
    Deleted: number;
    Id_User: number;
    Name: string;
    IsNewMessage: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/message-account.ts